var map = {
	"./1.png": "6XdX",
	"./2.png": "MxaQ",
	"./3.png": "F3mb",
	"./4.png": "M36D",
	"./5.png": "TsRu",
	"./6.png": "m6qg",
	"./7.png": "GiCK",
	"./8.png": "IUss",
	"./gf.png": "g1Ra",
	"./torvalds.png": "AhEW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FxGc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar nonrecursive \.(png|jpe?g|svg)$
// module id = FxGc
// module chunks = 1